import DepartmentServePreferencesCaseInfo from './DepartmentServePreferencesCaseInfo';
import DepartmentServePreferencesPatientInfo from './DepartmentServePreferencesPatientInfo';
import DepartmentServePreferencesDocumentsInfo from './DepartmentServePreferencesDocumentsInfo';

export default function DepartmentServePreferences({
	form,
	departmentFileTypes
}: {
	form: any;
	departmentFileTypes: any[];
}) {
	return (
		<>
			<DepartmentServePreferencesPatientInfo
				form={form} />

			<DepartmentServePreferencesCaseInfo
				form={form} />

			<DepartmentServePreferencesDocumentsInfo
				departmentFileTypes={departmentFileTypes}
				form={form} />

		</>
	)
}
